// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__81xnw","desabilitar":"OptionSelect_desabilitar__0L-1W","focado":"OptionSelect_focado__IEHb2","novo":"OptionSelect_novo__v3-H4"};